/* eslint-disable react/prop-types */
/* eslint-disable react-native/no-inline-styles */
/* eslint-disable react-native/no-color-literals */

import React, { useRef, useEffect } from 'react';
import { View, TouchableOpacity, ScrollView } from 'react-native';
import SociollaText from '@components/sociolla/SociollaText';
import Colors from '@global/colors';

// Max height + gap to its anchor, so a caller can check whether the dropdown fits.
export const MENTION_DROPDOWN_MAX_HEIGHT = 283;
export const MENTION_DROPDOWN_OFFSET = 8;

// placement: 'top' opens above the anchor (default, the compose box at the drawer bottom),
// 'bottom' opens below it — MessageItem picks one based on the room left in the comment list.
// maxHeight lets MessageItem shrink the dropdown to that room so it isn't clipped by the list.
const MentionDropdown = ({
  users,
  activeIndex,
  onSelect,
  hasMore,
  onLoadMore,
  placement = 'top',
  maxHeight = MENTION_DROPDOWN_MAX_HEIGHT,
}) => {
  // Rows have variable height (names can wrap to 2 lines), so keeping the highlighted row
  // in view for arrow-key navigation needs real measured offsets, not a fixed row-height guess.
  const scrollRef = useRef(null);
  const itemLayouts = useRef({});

  useEffect(() => {
    const layout = itemLayouts.current[activeIndex];
    if (layout && scrollRef.current) {
      scrollRef.current.scrollTo({
        y: Math.max(0, layout.y - 8),
        animated: true,
      });
    }
  }, [activeIndex]);

  if (!users.length) {
    return null;
  }

  return (
    <View
      testID="mention-dropdown"
      style={{
        position: 'absolute',
        ...(placement === 'bottom'
          ? { top: '100%', marginTop: MENTION_DROPDOWN_OFFSET }
          : { bottom: '100%', marginBottom: MENTION_DROPDOWN_OFFSET }),
        left: 0,
        width: 238,
        maxHeight,
        zIndex: 10,
        backgroundColor: Colors.white,
        borderRadius: 6,
        shadowColor: '#000',
        shadowOffset: { width: 0, height: 0 },
        shadowOpacity: 0.16,
        shadowRadius: 10,
        elevation: 6,
      }}>
      <ScrollView
        ref={scrollRef}
        onScroll={(e) => {
          if (!hasMore) {
            return;
          }
          const { contentOffset, contentSize, layoutMeasurement } =
            e.nativeEvent;
          const nearBottom =
            contentOffset.y + layoutMeasurement.height >=
            contentSize.height - 24;
          if (nearBottom) {
            onLoadMore?.();
          }
        }}
        scrollEventThrottle={100}>
        {users.map((user, idx) => (
          <TouchableOpacity
            testID={`mention-option-${user._id}`}
            key={user._id}
            activeOpacity={0.7}
            onPress={() => onSelect(user)}
            onLayout={(e) => {
              itemLayouts.current[idx] = e.nativeEvent.layout;
            }}
            style={{
              flexDirection: 'row',
              alignItems: 'center',
              paddingVertical: 10,
              paddingHorizontal: 12,
              backgroundColor:
                idx === activeIndex ? Colors.grey0 : Colors.white,
            }}>
            <View
              style={{
                width: 24,
                height: 24,
                borderRadius: 12,
                backgroundColor: Colors.blue0,
                alignItems: 'center',
                justifyContent: 'center',
                marginRight: 8,
              }}>
              <SociollaText
                style={{ color: Colors.white, fontSize: 10 }}
                type="bold">
                {(user.name || '')
                  .split(' ')
                  .filter(Boolean)
                  .slice(0, 2)
                  .map((n) => n[0]?.toUpperCase())
                  .join('')}
              </SociollaText>
            </View>
            <SociollaText numberOfLines={1} style={{ fontSize: 13, flex: 1 }}>
              {user.name}
            </SociollaText>
          </TouchableOpacity>
        ))}
      </ScrollView>
    </View>
  );
};

export default MentionDropdown;
